import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import HomePage from './HomePage';

const HomeRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('HomeRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={HomePage} />
            </Switch>
        </>
    );
};

export default HomeRoutes;
